import React from "react";
import { useTextResources } from "../../../language";
import PropTypes from "prop-types";
import NumericInput from "../../../components/shared/NumericInput";
import { Grid } from "semantic-ui-react";
import { AddonPricingType } from "../../../components/shared/constants";

export const AddonEditingTable = ({ prices, onChange, priceToUpdate, isDerived, doesPriceIncludeTax }) => {
  const text = useTextResources();

  const getPrice = (priceType, fieldName) =>
     prices?.find(x => x.PriceType === priceType)?.[fieldName];

  const allowanceValueToUse = doesPriceIncludeTax ? "AllowanceAfterTax" : "Allowance"
  const costValueToUse = doesPriceIncludeTax ? "CostAfterTax" : "Cost"

  const disabledClass = isDerived ? "disabled" : "";
  const inputClassName = `${disabledClass} property-input-highlighted`;
  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={2}></Grid.Column>
        <Grid.Column width={4} className={inputClassName}>
          {text("Adult")}
        </Grid.Column>
        <Grid.Column width={4} className={inputClassName}>
          {text("Child")}
        </Grid.Column>
        <Grid.Column width={4} className={inputClassName}>
          {text("Infant")}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={2} className={inputClassName}>
          {text("Price")}
        </Grid.Column>
        <Grid.Column width={4}>
          <NumericInput
            disabled={isDerived}
            selectOnFocus
            buttonPlacement="none"
            value={getPrice(AddonPricingType.Adult, priceToUpdate)}
            onChangeComplete={(value) => onChange(AddonPricingType.Adult, priceToUpdate, value)}
            className="addon-property-input"
          />
        </Grid.Column>
        <Grid.Column width={4}>
          <NumericInput
            disabled={isDerived}
            selectOnFocus
            buttonPlacement="none"
            value={getPrice(AddonPricingType.Child, priceToUpdate)}
            onChangeComplete={(value) => onChange(AddonPricingType.Child, priceToUpdate, value)}
            className="addon-property-input"
          />
        </Grid.Column>
        <Grid.Column width={4}>
          <NumericInput
            disabled={isDerived}
            selectOnFocus
            buttonPlacement="none"
            value={getPrice(AddonPricingType.Infant, priceToUpdate)}
            onChangeComplete={(value) => onChange(AddonPricingType.Infant, priceToUpdate, value)}
            className="addon-property-input"
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={2} className={inputClassName}>
          {text("Allowance")}
        </Grid.Column>
        <Grid.Column width={4}>
          <NumericInput
            disabled={isDerived}
            selectOnFocus
            buttonPlacement="none"
            value={getPrice(AddonPricingType.Adult, allowanceValueToUse)}
            onChangeComplete={(value) => onChange(AddonPricingType.Adult, allowanceValueToUse, value)}
            className="addon-property-input"
          />
        </Grid.Column>
        <Grid.Column width={4}>
          <NumericInput
            disabled={isDerived}
            selectOnFocus
            buttonPlacement="none"
            value={getPrice(AddonPricingType.Child, allowanceValueToUse)}
            onChangeComplete={(value) => onChange(AddonPricingType.Child, allowanceValueToUse, value)}
            className="addon-property-input"
          />
        </Grid.Column>
        <Grid.Column width={4}>
          <NumericInput
            disabled={isDerived}
            selectOnFocus
            buttonPlacement="none"
            value={getPrice(AddonPricingType.Infant, allowanceValueToUse)}
            onChangeComplete={(value) => onChange(AddonPricingType.Infant, allowanceValueToUse, value)}
            className="addon-property-input"
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={2} className={inputClassName}>
          {text("Cost")}
        </Grid.Column>
        <Grid.Column width={4}>
          <NumericInput
            disabled={isDerived}
            selectOnFocus
            buttonPlacement="none"
            value={getPrice(AddonPricingType.Adult, costValueToUse)}
            onChangeComplete={(value) => onChange(AddonPricingType.Adult, costValueToUse, value)}
            className="addon-property-input"
          />
        </Grid.Column>
        <Grid.Column width={4}>
          <NumericInput
            disabled={isDerived}
            selectOnFocus
            buttonPlacement="none"
            value={getPrice(AddonPricingType.Child, costValueToUse)}
            onChangeComplete={(value) => onChange(AddonPricingType.Child, costValueToUse, value)}
            className="addon-property-input"
          />
        </Grid.Column>
        <Grid.Column width={4}>
          <NumericInput
            disabled={isDerived}
            selectOnFocus
            buttonPlacement="none"
            value={getPrice(AddonPricingType.Infant, costValueToUse)}
            onChangeComplete={(value) => onChange(AddonPricingType.Infant, costValueToUse, value)}
            className="addon-property-input"
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

AddonEditingTable.propTypes = {
  priceToUpdate: PropTypes.string,
  prices: PropTypes.object,
  onChange: PropTypes.func,
  isDerived: PropTypes.bool,
  doesPriceIncludeTax: PropTypes.bool
};
